// extracted by mini-css-extract-plugin
module.exports = {"productIconRow":"product-icons_productIconRow__NNNQQ","icon":"product-icons_icon__TG9IP","productName":"product-icons_productName__FZeMg"};